import React from 'react';
import { Box, Typography } from '@mui/material';
import { Loader } from '@/components/loader/loader';
import {
  TopUnallocatedResource,
  UnallocatedByOwner,
} from '../hooks/useAllocation';
import { formatCurrencyNoUnit } from '@/lib/formatters';
import { SvgHBars } from '@/components/ds/charts';

interface AllocationBarChartProps {
  data: TopUnallocatedResource[] | UnallocatedByOwner[];
  isLoading?: boolean;
  currency?: string;
}

export const AllocationBarChart = ({
  data,
  isLoading = false,
  currency = 'USD',
}: AllocationBarChartProps) => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={400}>
        <Loader />
      </Box>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={400}>
        <Typography variant="body2" color="text.secondary">
          No data available
        </Typography>
      </Box>
    );
  }

  const isTopUnallocatedResource = (
    item: TopUnallocatedResource | UnallocatedByOwner,
  ): item is TopUnallocatedResource => {
    return 'name' in item;
  };

  const chartData = data.map((item) => {
    const rawName = isTopUnallocatedResource(item)
      ? item.name
      : item.ownerName;
    const displayName =
      rawName.length > 20 ? `${rawName.substring(0, 20)}...` : rawName;
    return {
      v: item.cost,
      l: displayName,
      c: '#1C71E3',
    };
  });

  return (
    <Box height={400} sx={{ overflowY: 'auto' }}>
      <SvgHBars
        data={chartData}
        fmt={formatCurrencyNoUnit}
        labelW={150}
      />
    </Box>
  );
};
